module.exports = __webpack_public_path__ + "assets/img/btn-back-5c9df117.png";